export const BULK_INVOICE_API_ERROR_ACTION = 'BULK_INVOICE_API_ERROR_ACTION';
export const GET_ORDERS_MAKE_INVICE_DATA_ACTION_SUCCESS = 'GET_ORDERS_MAKE_INVICE_DATA_ACTION_SUCCESS';


export const SAVE_BULK_INVOICE_ACTION = 'SAVE_BULK_INVOICE_ACTION';
export const SAVE_BULK_INVOICE_ACTION_SUCCESS = 'SAVE_BULK_INVOICE_ACTION_SUCCESS';

export const GET_ORDERS_MAKE_INVICE_DATA_ACTION = 'GET_ORDERS_MAKE_INVICE_DATA_ACTION';
